var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector = function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M7.45.892Q7.227.875 7 .875V0a7 7 0 0 1 .515.019zm1.754.393a6 6 0 0 0-.862-.261L8.534.17q.504.113.985.299zm1.199.622a6 6 0 0 0-.384-.236l.431-.762a7 7 0 0 1 .857.573l-.539.69a6 6 0 0 0-.365-.265m1.605 1.566a6 6 0 0 0-.572-.696l.634-.604q.356.375.653.796zm.65 1.183a6 6 0 0 0-.187-.41l.782-.393a7 7 0 0 1 .394.951l-.831.275a6 6 0 0 0-.157-.423m.465 2.194q-.011-.452-.088-.897l.862-.15q.088.51.1 1.025zm-.116 1.345q.045-.222.072-.445l.868.107a7 7 0 0 1-.2 1.01l-.844-.233q.06-.217.104-.44m-.832 2.082q.241-.382.425-.795l.8.355q-.21.472-.486.908zm-.844 1.054q.16-.16.307-.33l.662.571q-.168.195-.35.378z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M7 .875a6.125 6.125 0 1 0 4.331 10.456l.619.619A7 7 0 1 1 7 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M6.563 2.625c.241 0 .437.196.437.438V7.62l2.842 1.624a.438.438 0 0 1-.434.76l-3.063-1.75a.44.44 0 0 1-.22-.38V3.063c0-.242.196-.438.438-.438"
  })));
};
export default SvgVector;